import {
  getSessionItem,
  setSessionItem,
} from '@/core/services/session-storage/session-storage';

export const BOOKING_RETURN_PATH_STORAGE_KEY = 'mindoasisBookingReturnPath';

/**
 * Paths that count as an in-site page the booking location step can return to.
 * Excludes the booking funnel so opening /booking does not overwrite the prior page.
 */
export function isBookingReturnPath(pathname: string): boolean {
  if (!pathname.startsWith('/')) {
    return false;
  }

  return pathname !== '/booking' && !pathname.startsWith('/booking/');
}

export function getBookingReturnPath(): string | null {
  const path = getSessionItem(BOOKING_RETURN_PATH_STORAGE_KEY);
  if (!path || !isBookingReturnPath(path)) {
    return null;
  }
  return path;
}

export function setBookingReturnPath(pathname: string): void {
  if (!isBookingReturnPath(pathname)) {
    return;
  }
  setSessionItem(BOOKING_RETURN_PATH_STORAGE_KEY, pathname);
}

/** Whether the location-step header back should use browser history. */
export function canUseBookingLocationStepHistoryBack(): boolean {
  return getBookingReturnPath() !== null;
}
